import { render, staticRenderFns } from "./SuggestionListCertificate.vue?vue&type=template&id=0a777520&scoped=true&"
import script from "./SuggestionListCertificate.vue?vue&type=script&lang=js&"
export * from "./SuggestionListCertificate.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListCertificate.vue?vue&type=style&index=0&id=0a777520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a777520",
  null
  
)

export default component.exports